(ns kyber.events.location
  (:require [goog.object :as gobj]
            [re-frame.core :as re-frame]))

(re-frame/reg-fx
 :location/set!
 (fn [location]
   (gobj/set js/window "location" location)))
